export class PathFile {
    private filename: string;
    private extension: string;

    constructor(filename: string, extension: string) {
        this.filename = filename;
        this.extension = extension;
    }

    get Filename(): string { return this.filename; }
    set Filename(value: string) { this.filename = value; }

    get Extension(): string { return this.extension; }
    set Extension(value: string) { this.extension = value; }

    // public toJSON() {
    //     const json = `${this.filename}.${this.extension}`;
    //     return json;
    // }

    public toString(): string {
        const file = `${this.filename}.${this.extension}`;
        return file;
    }
}
